import { AfterViewChecked, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ServicesEcolesDisponibles, Instance } from '../../models/produit.model';
import { ProduitService } from '../../services/produit.service';

import { environment } from '../../../environments/environment';

import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'home-etablissements',
  templateUrl: './homeEtablissements.component.html',
  styleUrls: ['./homeEtablissements.component.scss']
})
export class HomeEtablissementsComponent implements OnInit, AfterViewChecked {
  environment = environment;

  servicesEcolesDisponibles1: ServicesEcolesDisponibles[];
  servicesEcolesDisponibles2: ServicesEcolesDisponibles[];
  servicesEcolesDisponibles3: ServicesEcolesDisponibles[];

  colored_produit: Array<number> = new Array<number>();
  show_villes: Array<string> = Array<string>();

  colorServiceEcole1Column = '';
  colorServiceEcole2Column = '';
  colorServiceEcole3Column = '';

  isLoadingServicesEcolesDisponibles1 = true;
  isLoadingServicesEcolesDisponibles2 = true;
  isLoadingServicesEcolesDisponibles3 = true;

  constructor(
    private produitService: ProduitService,
    private router: Router,
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object) {
  }

  ngOnInit() {
    this.titleService.setTitle('Centre de Formation du Languedoc - Espace Établissements Scolaires');
    this.metaTagService.updateTag({
      name: 'description',
      content: 'BTS SP3S, BTS MCO, BTS SIO'
    });
    this.getServices1();
    this.getServices2();
    this.getServices3();
  }

  ngAfterViewChecked() {
    if (!this.isLoadingServicesEcolesDisponibles1 && this.servicesEcolesDisponibles1 && this.servicesEcolesDisponibles1.length > 0) {
      this.servicesEcolesDisponibles1.forEach(service => {
        if (this.colored_produit.indexOf(service.id_produit) === -1) {
          this.setCardColors('service_' + service.id_instance, service.couleur_box, service.couleur_texte);
          this.colored_produit.push(service.id_produit);
      }
      });
    }
    if (!this.isLoadingServicesEcolesDisponibles2 && this.servicesEcolesDisponibles2 && this.servicesEcolesDisponibles2.length > 0) {
      this.servicesEcolesDisponibles2.forEach(service => {
        if (this.colored_produit.indexOf(service.id_produit) === -1) {
          this.setCardColors('service_' + service.id_instance, service.couleur_box, service.couleur_texte);
          this.colored_produit.push(service.id_produit);
      }
      });
    }
    if (!this.isLoadingServicesEcolesDisponibles3 && this.servicesEcolesDisponibles3 && this.servicesEcolesDisponibles3.length > 0) {
      this.servicesEcolesDisponibles3.forEach(service => {
        if (this.colored_produit.indexOf(service.id_produit) === -1) {
          this.setCardColors('service_' + service.id_instance, service.couleur_box, service.couleur_texte);
          this.colored_produit.push(service.id_produit);
      }
      });
    }
  }

  setCardColors(id, backgroundColor, textColor) {
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById(id).style.backgroundColor = backgroundColor;
      document.getElementById(id).style.color = textColor;
    }
  }

  getServices1(): void {
    this.produitService.getServiceEcole1().subscribe(
      (res: ServicesEcolesDisponibles[]) => {
        this.servicesEcolesDisponibles1 = res;
        if (this.servicesEcolesDisponibles1 && this.servicesEcolesDisponibles1.length > 0) {
          this.servicesEcolesDisponibles1.forEach(service => {
            service.url = this.getServiceEcoleLink(service);
            if (this.colorServiceEcole1Column === '' && service.couleur_box !== '') {
              this.colorServiceEcole1Column = service.couleur_box;
            }
            this.setBulletColor(service);
          });
        }
        this.isLoadingServicesEcolesDisponibles1 = false;
      },
      (err) => {
        console.log(err);
        this.isLoadingServicesEcolesDisponibles1 = false;
      }
    );
  }

  getServices2(): void {
    this.produitService.getServiceEcole2().subscribe(
      (res: ServicesEcolesDisponibles[]) => {
        this.servicesEcolesDisponibles2 = res;
        if (this.servicesEcolesDisponibles2 && this.servicesEcolesDisponibles2.length > 0) {
          this.servicesEcolesDisponibles2.forEach(service => {
            service.url = this.getServiceEcoleLink(service);
            if (this.colorServiceEcole2Column === '' && service.couleur_box !== '') {
              this.colorServiceEcole2Column = service.couleur_box;
            }
            this.setBulletColor(service);
          });
        }
        this.isLoadingServicesEcolesDisponibles2 = false;
      },
      (err) => {
        console.log(err);
        this.isLoadingServicesEcolesDisponibles2 = false;
      }
    );
  }

  getServices3(): void {
    this.produitService.getServiceEcole3().subscribe(
      (res: ServicesEcolesDisponibles[]) => {
        this.servicesEcolesDisponibles3 = res;
        if (this.servicesEcolesDisponibles3 && this.servicesEcolesDisponibles3.length > 0) {
          this.servicesEcolesDisponibles3.forEach(service => {
            service.url = this.getServiceEcoleLink(service);
            if (this.colorServiceEcole3Column === '' && service.couleur_box !== '') {
              this.colorServiceEcole3Column = service.couleur_box;
            }
            this.setBulletColor(service);
          });
        }
        this.isLoadingServicesEcolesDisponibles3 = false;
      },
      (err) => {
        console.log(err);
        this.isLoadingServicesEcolesDisponibles3 = false;
      }
    );
  }

  setBulletColor(produitDisponible: ServicesEcolesDisponibles) {
    if (produitDisponible.couleur_box && produitDisponible.couleur_box !== '') {
      const hexa = produitDisponible.couleur_box;
      const color_1 = parseInt(hexa.slice(1, 3).toString(), 16);
      const color_2 = parseInt(hexa.slice(3, 5).toString(), 16);
      const color_3 = parseInt(hexa.slice(5, 7).toString(), 16);
      const total = color_1 + color_2 + color_3;
      if (total > 470) {
        produitDisponible.isBulletPointBlack = true;
      } else {
        produitDisponible.isBulletPointBlack = false;
      }
    }
  }

  onServiceEcoleClick(item) {
    if (item.value) {
      if (item.value.length > 1) {
        const index = this.show_villes.indexOf(item.value[0].id_instance);
        if (index === -1) {
          this.show_villes.push(item.value[0].id_instance);
        } else {
          this.show_villes.splice(index, 1);
        }
      }
    }
  }

  getServiceEcoleLink(instance) {
    const titre_produit = this.setHtmlReadable(instance.titre_produit);
    const nom_instance = this.setHtmlReadable(instance.nom_instance);
    return '/services-aux-etablissements-scolaires/' + titre_produit + '/' + nom_instance + '/' + instance.id_instance;
  }

  setHtmlReadable(name): string {
    name = name.toLowerCase();
    name = name.split(' ').join('-');
    name = name.split('à').join('a');
    name = name.split('ç').join('c');
    name = name.split('è').join('e');
    name = name.split('é').join('e');
    name = name.split('ë').join('e');
    name = name.split('ï').join('i');
    name = name.split('ô').join('o');
    name = name.split('û').join('u');
    name = name.split('(').join('');
    name = name.split(')').join('');
    name = name.split('<br>').join('');
    name = name.split('&').join('');
    name = name.split('----').join('-');
    name = name.split('---').join('-');
    name = name.split('--').join('-');
    return name;
  }

}
